<template>
  <main class="page-operative page-operative-fiscal-data d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Credito d'imposta</PageTitle>
      </div>
      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <div class="overflow-auto report-texts-size">
            <OperativeTable dense sticky>
              <tbody>
              <OperativeTableBodyHeader :years="tableHeadings" show-years>Aggregato</OperativeTableBodyHeader>
              <OperativeTableBodyRow :values="tableRows.f24OneriSociali">
                F24 Oneri Sociali
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.f24Iva">
                F24 IVA
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.f24Imposte">
                F24 Imposte
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.f24RitenutePersonale">
                F24 Ritenute Personale
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.f24RitenuteProfessionisti">
                F24 Ritenute Professionisti
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.totaleF24">
                Totale F24
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.erogazioneCreditoImposta">
                Erogazione Credito d'Imposta
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.utilizzoCreditoImposta">
                Utilizzo Credito d'Imposta
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="tableRows.creditoImpostaDisponibile">
                Credito d'Imposta Disponibile
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              </tbody>
            </OperativeTable>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../mixins/operativePage';
import loadingDataMixin from '../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../mixins/computedFinancialData';
import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'page-operative-company-fiscal-data-dinamica-iva',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin],
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../components/Operative/LoadingDataLoader'),
    OperativeTable: () => import('../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../components/Operative/OperativeTableBodyRow'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  data () {
    return {
      months: [],
    };
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getComputedCreditoImposta(this.company?.id)
        .then(res => {
          this.months = res?.data?.months || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
  },
  computed: {
    tableHeadings () {
      return this.convertToMonthsHeading(this.months);
    },
    tableRows () {
      return this.convertToRowGroupAutomatically(this.months);
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>
